import { cn } from '@/lib/cn'

export function Spinner({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={cn('h-5 w-5 shrink-0 animate-spin text-accent', className)}
      role="status"
      aria-label="Loading"
    >
      <circle
        cx="12"
        cy="12"
        r="9"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeDasharray="44"
        strokeDashoffset="32"
      />
    </svg>
  )
}

/**
 * Placeholder block used while a region's data loads.
 *
 * A shimmer rather than a pulse: a pulse blinks the whole block on and off,
 * which at a glance reads as something failing rather than something arriving.
 */
export function Skeleton({ className }: { className?: string }) {
  return <div className={cn('skeleton rounded-md', className)} aria-hidden="true" />
}

export function LoadingPanel({ label = 'Loading…' }: { label?: string }) {
  return (
    <div
      className="flex flex-col items-center justify-center gap-3 px-6 py-16"
      role="status"
      aria-live="polite"
    >
      <Spinner />
      <p className="text-sm text-ink-secondary">{label}</p>
    </div>
  )
}
